// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiFetch from "lumi-rescript/lib/es6/src/LumiFetch.res.js";
import * as V3$Linear from "lumi-linear/lib/es6/src/V3.res.js";
import * as Dialog$Web from "lumi-web/lib/es6/src/Dialog.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Belt_Option from "@rescript/runtime/lib/es6/Belt_Option.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as DateTime$LumiI18n from "lumi-i18n/lib/es6/src/DateTime.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.res.js";

let options = [
  "FixedIpAddress",
  "AutomaticIpAddress"
];

let jsonCodec = LumiJzon.anySumAsString(options, undefined);

let IpAddressMode = {
  options: options,
  jsonCodec: jsonCodec
};

let IpAddress = {
  jsonCodec: Jzon.string
};

let jsonCodec$1 = Jzon.object3(param => [
  param.free,
  param.occupied,
  param.error
], param => ({
  TAG: "Ok",
  _0: {
    free: param[0],
    occupied: param[1],
    error: param[2]
  }
}), Jzon.field("free", Jzon.int), Jzon.field("occupied", Jzon.int), Jzon.field("error", Jzon.int));

let oneFree = {
  free: 1,
  occupied: 0,
  error: 0
};

let oneOccupied = {
  free: 0,
  occupied: 1,
  error: 0
};

let oneError = {
  free: 0,
  occupied: 0,
  error: 1
};

let options$1 = [
  oneFree,
  oneOccupied,
  oneError
];

function add(a, b) {
  return {
    free: a.free + b.free | 0,
    occupied: a.occupied + b.occupied | 0,
    error: a.error + b.error | 0
  };
}

function className(measurement) {
  let match = measurement.free;
  if (match !== 0) {
    if (match !== 1 || measurement.occupied !== 0 || measurement.error !== 0) {
      return "facility-map-spot-error";
    } else {
      return "facility-map-spot-free";
    }
  } else if (measurement.occupied !== 1 || measurement.error !== 0) {
    return "facility-map-spot-error";
  } else {
    return "facility-map-spot-occupied";
  }
}

function translate(locale, entry) {
  switch (locale) {
    case "ENG" :
      let match = entry.free;
      if (match !== 0) {
        if (match !== 1 || entry.occupied !== 0 || entry.error !== 0) {
          return "Measurement error";
        } else {
          return "Free";
        }
      } else if (entry.occupied !== 1 || entry.error !== 0) {
        return "Measurement error";
      } else {
        return "Occupied";
      }
    case "NLD" :
      let match$1 = entry.free;
      if (match$1 !== 0) {
        if (match$1 !== 1 || entry.occupied !== 0 || entry.error !== 0) {
          return "Meetfout";
        } else {
          return "Vrij";
        }
      } else if (entry.occupied !== 1 || entry.error !== 0) {
        return "Meetfout";
      } else {
        return "Bezet";
      }
    default:
      return;
  }
}

let T = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate
});

let SensorMeasurement_empty = {
  free: 0,
  occupied: 0,
  error: 0
};

let SensorMeasurement = {
  jsonCodec: jsonCodec$1,
  empty: SensorMeasurement_empty,
  oneFree: oneFree,
  oneOccupied: oneOccupied,
  oneError: oneError,
  options: options$1,
  add: add,
  className: className,
  T: T
};

function jsonCodec$2(thisCodec) {
  return Jzon.object2(param => [
    param.time,
    param.this
  ], param => ({
    TAG: "Ok",
    _0: {
      time: param[0],
      this: param[1]
    }
  }), Jzon.field("when", LumiDate.DateTime.jsonCodec), Jzon.field("this", thisCodec));
}

function map(param, f) {
  return {
    time: param.time,
    this: f(param.this)
  };
}

async function decodeAtTime(response, f) {
  return Stdlib_Result.map(await f(response), $$this => {
    let time = Stdlib_Result.getOr(LumiFetch.Header.decodeString(response.headers, "Date", LumiDate.Private.$$Date.fromString), new Date());
    return {
      time: time,
      this: $$this
    };
  });
}

function wrapAtTime(request) {
  return {
    baseUrl: request.baseUrl,
    params: request.params,
    init: request.init,
    decode: response => decodeAtTime(response, request.decode)
  };
}

let Fetch = {
  decodeAtTime: decodeAtTime,
  wrapAtTime: wrapAtTime
};

let AtTime = {
  jsonCodec: jsonCodec$2,
  map: map,
  Fetch: Fetch
};

function jsonCodec$3(errorCodec) {
  return Jzon.object2(param => [
    param.first,
    param.last
  ], param => ({
    TAG: "Ok",
    _0: {
      first: param[0],
      last: param[1]
    }
  }), Jzon.field("first", jsonCodec$2(errorCodec)), Jzon.field("last", jsonCodec$2(errorCodec)));
}

let ErrorRun = {
  jsonCodec: jsonCodec$3
};

function jsonCodec$4(errorCodec) {
  let errorRunCodec = jsonCodec$3(errorCodec);
  return LumiJzon.taggedVariant(value => {
    if (value.TAG === "OkSince") {
      return [
        "OkSince",
        Jzon.encodeWith(value._0, LumiDate.DateTime.jsonCodec)
      ];
    } else {
      return [
        "InError",
        Jzon.encodeWith(value._0, errorRunCodec)
      ];
    }
  }, param => {
    let contents = param[1];
    let tag = param[0];
    switch (tag) {
      case "InError" :
        return Stdlib_Result.map(Jzon.decodeWith(contents, errorRunCodec), errorRun => ({
          TAG: "InError",
          _0: errorRun
        }));
      case "OkSince" :
        return Stdlib_Result.map(Jzon.decodeWith(contents, LumiDate.DateTime.jsonCodec), timestamp => ({
          TAG: "OkSince",
          _0: timestamp
        }));
      default:
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              tag
            ]
          }
        };
    }
  }, undefined, undefined);
}

function isOk(state) {
  return state.TAG === "OkSince";
}

function isError(state) {
  return state.TAG !== "OkSince";
}

function errorRun(state) {
  if (state.TAG === "OkSince") {
    return;
  } else {
    return state._0;
  }
}

function Types$ErrorState$Modal$Error(props) {
  let match = props.error;
  let time = match.time;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs("p", {
        children: [
          JsxRuntime.jsx("span", {
            children: props.icon,
            className: "icon has-text-warning"
          }),
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(DateTime$LumiI18n.Full.make, {
              date: time
            })
          }),
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(DateTime$LumiI18n.DistanceToNow.make, {
              date: time,
              addSuffix: true
            }),
            className: "tag is-light is-text ml-1"
          })
        ],
        className: "icon-text"
      }),
      JsxRuntime.jsx("pre", {
        children: props.toString(match.this),
        style: {
          whiteSpace: "pre-wrap"
        }
      })
    ]
  });
}

let $$Error = {
  make: Types$ErrorState$Modal$Error
};

function Types$ErrorState$Modal(props) {
  let toString = props.toString;
  let __active = props.active;
  let errorState = props.errorState;
  let active = __active !== undefined ? __active : true;
  let tmp;
  if (errorState.TAG === "OkSince") {
    let date = errorState._0;
    tmp = JsxRuntime.jsxs("p", {
      children: [
        JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
            name: "circle-check"
          }),
          className: "icon has-text-info"
        }),
        JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(DateTime$LumiI18n.Full.make, {
            date: date
          })
        }),
        JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(DateTime$LumiI18n.DistanceToNow.make, {
            date: date,
            includeSeconds: true
          }),
          className: "tag is-light is-text ml-1"
        })
      ],
      className: "icon-text"
    });
  } else {
    let match = errorState._0;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Types$ErrorState$Modal$Error, {
          toString: toString,
          error: match.first,
          icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
            name: "clock-rotate-left"
          })
        }),
        JsxRuntime.jsx(Types$ErrorState$Modal$Error, {
          toString: toString,
          error: match.last,
          icon: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
            name: "right-to-bracket"
          })
        })
      ]
    });
  }
  return JsxRuntime.jsxs(Dialog$Web.make, {
    showDialog: active,
    closeDialog: props.close,
    children: [
      JsxRuntime.jsx("header", {
        children: JsxRuntime.jsx("p", {
          children: props.title,
          className: "modal-card-title"
        }),
        className: "modal-card-head"
      }),
      JsxRuntime.jsx("section", {
        children: tmp,
        className: "modal-card-body"
      })
    ]
  });
}

let Modal = {
  $$Error: $$Error,
  make: Types$ErrorState$Modal
};

let ErrorState = {
  jsonCodec: jsonCodec$4,
  isOk: isOk,
  isError: isError,
  errorRun: errorRun,
  Modal: Modal
};

let options$2 = [
  "Http",
  "Https"
];

function getDefaultPort(protocol) {
  if (protocol === "Http") {
    return 80;
  } else {
    return 443;
  }
}

function stringCodec_toString(protocol) {
  if (protocol === "Http") {
    return "Http";
  } else {
    return "Https";
  }
}

function stringCodec_fromString(str) {
  switch (str) {
    case "Cam_Http" :
    case "Http" :
      return "Http";
    case "Cam_Https" :
    case "Https" :
      return "Https";
    default:
      return;
  }
}

let stringCodec = {
  toString: stringCodec_toString,
  fromString: stringCodec_fromString
};

let jsonCodec$5 = LumiJzon.stringCodec(stringCodec);

function translate$1(_locale, entry) {
  if (entry === "Http") {
    return "Http";
  } else {
    return "Https";
  }
}

let T$1 = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate$1
});

let Protocol = {
  options: options$2,
  getDefaultPort: getDefaultPort,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$5,
  T: T$1
};

let JsUrl = {};

function toJsUrl(baseUrl) {
  return new URL(stringCodec_toString(baseUrl.scheme) + "://" + baseUrl.host + ":" + baseUrl.port.toString() + baseUrl.path);
}

function stringCodec_toString$1(baseUrl) {
  let jsUrl = toJsUrl(baseUrl);
  let str = jsUrl.toString();
  if (jsUrl.pathname.length === 1) {
    return str.slice(0, str.length - 1 | 0);
  } else {
    return str;
  }
}

function stringCodec_fromString$1(str) {
  try {
    let jsUrl = new URL(str);
    let match = jsUrl.protocol;
    let tmp;
    switch (match) {
      case "http:" :
        tmp = "Http";
        break;
      case "https:" :
        tmp = "Https";
        break;
      default:
        tmp = undefined;
    }
    let scheme = Belt_Option.getExn(tmp);
    let p = Stdlib_Int.fromString(jsUrl.port, undefined);
    let port = p !== undefined ? p : getDefaultPort(scheme);
    return {
      scheme: scheme,
      host: jsUrl.hostname,
      port: port,
      path: jsUrl.pathname
    };
  } catch (exn) {
    return;
  }
}

let stringCodec$1 = {
  toString: stringCodec_toString$1,
  fromString: stringCodec_fromString$1
};

let jsonCodec$6 = LumiJzon.stringCodec(stringCodec$1);

let BaseUrl = {
  toJsUrl: toJsUrl,
  stringCodec: stringCodec$1,
  jsonCodec: jsonCodec$6
};

let options$3 = [
  "Open",
  "Closed"
];

let jsonCodec$7 = LumiJzon.anySumAsString(options$3, prim => prim.toLowerCase());

function translate$2(locale, entry) {
  switch (locale) {
    case "ENG" :
      if (entry === "Open") {
        return "Open";
      } else {
        return "Closed";
      }
    case "NLD" :
      if (entry === "Open") {
        return "Geopend";
      } else {
        return "Gesloten";
      }
    default:
      return;
  }
}

let T$2 = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate$2
});

let OpenClosedState = {
  options: options$3,
  jsonCodec: jsonCodec$7,
  T: T$2
};

let jsonCodec$8 = LumiJzon.taggedVariantOptionalContents(v => {
  if (typeof v !== "object") {
    if (v === "DontSync") {
      return [
        "DontSync",
        undefined
      ];
    } else {
      return [
        "SyncNow",
        undefined
      ];
    }
  } else {
    return [
      "SyncAfter",
      Jzon.encodeWith(v._0, LumiDate.DateTime.jsonCodec)
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "DontSync" :
      return {
        TAG: "Ok",
        _0: "DontSync"
      };
    case "SyncAfter" :
      let stamp = pair[1];
      if (stamp !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(stamp, LumiDate.DateTime.jsonCodec), x => ({
          TAG: "SyncAfter",
          _0: x
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    case "SyncNow" :
      return {
        TAG: "Ok",
        _0: "SyncNow"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

let SyncMode = {
  jsonCodec: jsonCodec$8
};

function fromString(str) {
  return Stdlib_Int.fromString(str, 16);
}

function toString(value) {
  return value.toString(16).padStart(2, "0");
}

let Channel = {
  fromString: fromString,
  toString: toString
};

function toString$1(param) {
  return toString(param.red) + toString(param.green) + toString(param.blue);
}

function fromString$1(str) {
  if (str.length === 6) {
    return Stdlib_Option.map(LumiOption.sequence3(V3$Linear.map([
      str.substring(0, 2),
      str.substring(2, 4),
      str.substring(4, 6)
    ], fromString)), param => ({
      red: param[0],
      green: param[1],
      blue: param[2]
    }));
  }
}

let stringCodec$2 = {
  toString: toString$1,
  fromString: fromString$1
};

let jsonCodec$9 = LumiJzon.stringCodec(stringCodec$2);

function toCSS(color) {
  return "#" + toString$1(color);
}

let Color_black = {
  red: 0,
  green: 0,
  blue: 0
};

let Color_white = {
  red: 255,
  green: 255,
  blue: 255
};

let Color_red = {
  red: 255,
  green: 0,
  blue: 0
};

let Color_green = {
  red: 0,
  green: 255,
  blue: 0
};

let Color_blue = {
  red: 0,
  green: 0,
  blue: 255
};

let Color_orange = {
  red: 255,
  green: 96,
  blue: 0
};

let Color = {
  Channel: Channel,
  toString: toString$1,
  fromString: fromString$1,
  stringCodec: stringCodec$2,
  jsonCodec: jsonCodec$9,
  toCSS: toCSS,
  black: Color_black,
  white: Color_white,
  red: Color_red,
  green: Color_green,
  blue: Color_blue,
  orange: Color_orange
};

let options$4 = [
  "CardinalDirectionNorth",
  "CardinalDirectionNorthEast",
  "CardinalDirectionEast",
  "CardinalDirectionSouthEast",
  "CardinalDirectionSouth",
  "CardinalDirectionSouthWest",
  "CardinalDirectionWest",
  "CardinalDirectionNorthWest"
];

let jsonCodec$10 = LumiJzon.anySumAsString(options$4, __x => __x.substring("CardinalDirection".length));

let CardinalDirection = {
  options: options$4,
  jsonCodec: jsonCodec$10
};

let GeoLocation;

export {
  IpAddressMode,
  IpAddress,
  SensorMeasurement,
  AtTime,
  ErrorRun,
  ErrorState,
  Protocol,
  JsUrl,
  BaseUrl,
  GeoLocation,
  OpenClosedState,
  SyncMode,
  Color,
  CardinalDirection,
}
/* jsonCodec Not a pure module */
